import { createSelector } from 'reselect'

export const selectIndicators = store => store.indicators.indicators

export const selectIndicator = createSelector(
  selectIndicators,
  (_, props) => props.key,
  (indicators, key) => indicators[key]
)
